const trackingUtils = require('od-modules/utils/tracking.utils');
const trackFrontEventsUtils = require('od-modules/track_events/track.frontevents.utils');

(function() {
    'use strict';

    Odigeo.UIElements.dialogs = [];

    Odigeo.UIElements.widgetsDialogs = [];

    /**
     Generates a dialog with header, message and buttons
     @param {(String|Object)} options (headerText)- If is string to show in dialog header. If is an Object is parameter to configure dialog.
     @param {String} options.headerText - to show in dialog header
     @param {String|$} options.content - to show in dialog body
     @param {Array|$} options.buttons - buttons to show (objects with button description for createButton() method)
     @param {String} options.dialogClasses - string of classes to add in dialog
     @param {Boolean} options.hasCloseButton - flag which indicates if exists close button
     @param {String} options.imageClass - string of imageClass
     @param {Boolean} options.closeOnTapOuterBox flag which indicates if dialog must be closed when tap on outer of box dialog
     @param {String} options.dialogID the dialog id
     deprecated:
     @param {String|$} [content] - alias of options.content
     @param {Array|$} [buttons] - alias of options.buttons
     @param {String} [dialogClasses] alias of options.dialogClasses
     @param {Boolean} [hasCloseButton] - alias of options.hasCloseButton
     @param {String} [imageClass] - string of imageClass
     @param {String} [dialogID] - alias of options.dialogID
     @return {$} Dialog object
     */
    Odigeo.UIElements.createDialog = function(options, content, buttons, dialogClasses, hasCloseButton, imageClass, dialogID) {
        // Do you need another argument if you want to improve customization of dialog?
        // I think that doesn't.
        // Now dialog can be created with only one object parameter `options` and if you need add new customizations use properties of this object.
        // Notice: Old implementation is preserved to not break the code.
        var closeOnTapOuterBox;
        var closeOnNavigate;
        var hiddenCloseButton;
        var headerText = options;
        var footerText;
        var id;
        if (Odigeo._.isObject(options)) {
            headerText = options.headerText;
            content = options.content;
            buttons = options.buttons || [];
            dialogClasses = options.dialogClasses;
            hasCloseButton = options.hasCloseButton;
            imageClass = options.imageClass;
            closeOnTapOuterBox = options.closeOnTapOuterBox;
            closeOnNavigate = options.closeOnNavigate;
            footerText = options.footerText;
            hiddenCloseButton = options.hiddenClose;
            dialogID = options.dialogID;
            id = options.id || '';
        }

        var classes = (Odigeo._.isArray(dialogClasses) ? dialogClasses.join(' ') : dialogClasses || '') + ' dialog-' + dialogID;
        var $dialog = $('<div>')
            .data('id', id)
            .attr('data-id', dialogID || id)
            .addClass('od-ui-dialog dialog ' + classes)
            .addClass(Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ? 'prisma-responsive-space-horizontal' : '')
            .append($('<div>')
                .addClass('od-ui-dialog-content dialog_content')
                .addClass(Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ? 'prisma-lightbox-wrapper' : ''));

        var hideDialog = function(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            Odigeo.UIElements.hideDialog($dialog);
            return false;
        };
        var stopPropagation = function(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            return false;
        };
        this.dialogs.push($dialog);

        const dialogBoxContentClass = Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix
            ? 'odf-text-neutral-700 odf-text-center odf-space-outer-bottom-m '
            : 'od-ui-dialog-box-content ';
        const dialogBoxClass = Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ? 'odf-space-inner-xl' : 'od-ui-dialog-box';
        const dialogBoxHeaderClass = Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix
            ? 'odf-text-center prisma-heading-md odf-text-neutral-700 odf-space-outer-bottom-m'
            : 'od-ui-dialog-box-header';
        const dialogBoxTitleClass = Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ? '' : 'od-ui-dialog-box-title';
        const dialogFooterClass = Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ? '' : 'od-ui-dialog-box-footer';

        var $boxContent = Odigeo._.isUndefined(imageClass) ?
            $('<div>').addClass(dialogBoxContentClass) :
            $('<div>').addClass(dialogBoxContentClass + imageClass);
        // If `content` is a $ instance allow appending it.
        $boxContent[content instanceof $ ? 'append' : 'html'](content);
        var closeButtonClasses = 'dialog_close_hint_icon ficon ficon-close od-ui-dialog-hint-icon' + (hiddenCloseButton ? 'odf-hidden' : '');
        $dialog.find('.dialog_content')
            .append($('<div>').addClass('ui_dialog_box').addClass(dialogBoxClass)
                .append(!Odigeo._.isUndefined(imageClass) ? $('<div>').addClass('od-ui-dialog-image-' + imageClass)
                    .append($('<span>').addClass('ficon').append('F'))
                    : '')
                .append($('<div>').addClass('dialog_box_header').addClass(dialogBoxHeaderClass)
                    .append((Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ? $('<div>') : $('<h3>'))
                        .addClass(dialogBoxTitleClass).html(headerText)))
                .append(hasCloseButton ? $('<div>').addClass(closeButtonClasses)
                    .append($('<span>').addClass('od-ui-dialog-close-hint-icon').append('r'))
                    : '')
                .append($boxContent)
                .append($('<div>').addClass('dialog_footer').addClass(dialogFooterClass))
            );
        if (footerText) {
            $dialog.find('.od-ui-dialog-box').append($('<div>').addClass('od-ui-dialog-box-post-footer dialog_post_footer').html(footerText));
        }

        var $buttonContainer = $dialog.find('.dialog_footer');

        $dialog.find('.dialog_dial_up').on(Odigeo.Events.tap, function() {
            var target = 'tel:' + this.attributes['attr-tel'].value;
            window.open(target, '_self');
        });

        if (hasCloseButton) {
            $dialog.find('.dialog_close_hint_icon').on(Odigeo.Events.tap, hideDialog);
        }
        if (closeOnTapOuterBox) {
            $dialog.find('.ui_dialog_box').on(Odigeo.Events.tap, stopPropagation);
            $dialog.on(Odigeo.Events.tap, hideDialog);
        }

        if (closeOnNavigate) {
            $dialog.on('dialog:closeOnNavigate', hideDialog);
        }

        var btnCount = buttons.length;
        var $button;

        Odigeo._.each(buttons, function(btn) {
            if (btn instanceof $) {
                $button = btn;
            } else {
                $button = Odigeo.UIElements.createButton(btn);
            }

            $buttonContainer.append(
                $('<div>').addClass('od-ui-dialog-btn-' + btnCount).append($button)
            );
        });

        if (dialogID) {
            $dialog.data('dialog-id', dialogID);
        }

        Odigeo.UIElements.dialog = $dialog; // TODO is this used at all?
        return $dialog.on(Odigeo.Events.touchmove, function(e) {
            e.preventDefault();
            e.stopPropagation();
        });
    };

    /**
     Attaches popup (dialog/notification/etc.) to the page
     @param {$} [$dialog] object representing popup
     @param {Boolean} [doNotScroll] do not scroll to top
     */
    Odigeo.UIElements.showDialog = function($dialog, doNotScroll) {
        $('.od_page.active .focused *').blur();
        $('.od_page.active select').each(function() {
            this.blur();
        });

        // Avoid scroll problems when showing a dialog
        if (Odigeo.SessionScope.flow === 'mobile') {
            // Hide keyboard
            Odigeo._.delay(function() {
                $(':focus').blur();
            }, 300);

            // Show dialog and scroll to top
            Odigeo._.delay(function() {
                Odigeo.Device.getViewport().append($dialog);
                $dialog.data('detached', false);
                if (!doNotScroll) {
                    $(window).scrollTop(0);
                }
            }, 500);
        } else {
            Odigeo.Device.getViewport().append($dialog);
            $dialog.data('detached', false);
        }

        trackFrontEventsUtils.trackJQElementDisplayed($dialog);
        if (Odigeo.AB.isGoBackNativeMessage) {
            window.onbeforeunload = null;
        }
        Odigeo.trigger('dialogs:shown');
    };

    Odigeo.UIElements.toggleHideCloseButtonDialog = function($dialog, hide) {
        $dialog.find('.dialog_close_hint_icon').toggleClass('odf-hidden', hide);
    };

    Odigeo.UIElements.toggleCloseOutterClick = function($dialog, enable) {
        var stopPropagation = function(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            return false;
        };

        var $uiDialog = $dialog.find('.ui_dialog_box');
        $uiDialog.off();
        $dialog.off();
        if (enable) {
            $uiDialog.on(Odigeo.Events.tap, stopPropagation);
            $dialog.on(Odigeo.Events.tap, function(evt) {
                stopPropagation(evt);
                Odigeo.UIElements.hideDialog($dialog);
                return false;
            });
        }
    };

    /**
     Detaches popup (dialog/notification/etc.) from the page
     @param {$} [$dialog] object representing popup
     */
    Odigeo.UIElements.hideDialog = function($dialog) {
        // Show logo
        $('#page .logo').removeClass('hidden');
        $dialog.detach();

        if (!$dialog.data('detached')) {
            Odigeo.trigger('dialogs:hidden', {dialogID: $dialog.data('dialog-id')});
            $dialog.data('detached', true);
        }
    };

    Odigeo.UIElements.hideAllDialogs = function() {
        Odigeo._.each(this.dialogs, this.hideDialog);
    };

    Odigeo.UIElements.toggleWidgetsDialogs = function(id, isOpen) {
        if (isOpen) {
            this.widgetsDialogs.push(id);
        } else {
            this.widgetsDialogs = Odigeo._.without(this.widgetsDialogs, id);
        }
    };

    Odigeo.UIElements.enhanceConfirmationDialog = function(popupDiv, okCallback, cancelCallback) {
        var $el;
        var showPopup;
        var hideDialog;
        var saveChanges;
        var discardChanges;

        $el = (popupDiv instanceof $) ? popupDiv : $(popupDiv);

        showPopup = function() {
            Odigeo.UIElements.showDialog($el);
            $el.find('.dialog_close_hint_icon').on(Odigeo.Events.tap, hideDialog);
            $el.find('.dialog_btn_save').on(Odigeo.Events.tap, saveChanges);
            $el.find('.dialog_btn_discard').on(Odigeo.Events.tap, discardChanges);
        };

        hideDialog = function() {
            $el.find('.dialog_close_hint_icon, .dialog_btn_save, .dialog_btn_discard').off(Odigeo.Events.tap);
            $el.detach();
        };

        saveChanges = function() {
            okCallback();
            hideDialog();
        };

        discardChanges = function() {
            cancelCallback();
            hideDialog();
        };

        return {
            show: showPopup,
            hide: hideDialog,
        };
    };

    // Ready-made dialogs
    Odigeo.UIElements.show0Error = function() {
        if ( Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ) {
            Odigeo.UIElements.Cobalt.showErrorDialogByTemplate(0);
        } else {
            const translations = Odigeo.UIElements.translations.err0;
            const popup = this.createDialog({
                id: `${Odigeo.SessionScope.flowProduct}-popup-broken-flow`,
                headerText: translations.header,
                content: translations.content,
                dialogClasses: 'no-background dialog_error',
                buttons: [{
                    text: translations.button,
                    style: 'od-ui-dialog-button-default',
                    handler: function() {
                        Odigeo.UIElements.hideDialog(popup);
                        window.location.href = translations.link;
                    },
                }],
            });
            this.hideAllDialogs();
            this.showDialog(popup);
        }
    };

    Odigeo.UIElements.show404Error = function() {
        if ( Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ) {
            Odigeo.UIElements.Cobalt.showErrorDialogByTemplate(404);
        } else {
            const translations = Odigeo.UIElements.translations.err404;
            const popup = Odigeo.UIElements.createDialog({
                id: `${Odigeo.SessionScope.flowProduct}-popup-broken-flow`,
                headerText: translations.header,
                content: translations.content,
                dialogClasses: 'no-background dialog_error',
            });

            // Analytics: event tracking
            Odigeo.trigger('analytics:tracking', {
                type: 'trackEvent',
                data: {
                    page: Odigeo.History.getPageNameFromFragment(),
                    action: 'back_end_errors',
                    label: '404_screen_error',
                },
            });

            this.hideAllDialogs();
            this.showDialog(popup);
        }
    };

    Odigeo.UIElements.show500Error = function(image) {
        if ( Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ) {
            Odigeo.UIElements.Cobalt.showErrorDialogByTemplate(500);
        } else {
            const translations = Odigeo.UIElements.translations.err500;
            let button;
            let popup;

            if (image) {
                popup = Odigeo.UIElements.createDialog({
                    id: `${Odigeo.SessionScope.flowProduct}-popup-broken-flow`,
                    headerText: '',
                    content: '<div class="od-ui-dialog-image-err500"></div>',
                    dialogClasses: 'white-background aligned-top dialog_error',
                    imageClass: 'image-padding',
                });
            } else {
                button = {
                    text: translations.button,
                    style: 'od-ui-dialog-button-default',
                    handler: function() {
                        Odigeo.UIElements.hideDialog(popup);
                        window.location.href = translations.link;
                    },
                };

                popup = Odigeo.UIElements.createDialog({
                    id: `${Odigeo.SessionScope.flowProduct}-popup-broken-flow`,
                    headerText: translations.header,
                    content: translations.content,
                    buttons: [button],
                    dialogClasses: 'no-background dialog_error',
                });
            }

            this.hideAllDialogs();
            this.showDialog(popup);
        }
    };

    Odigeo.UIElements.showBookingAlreadyDone = function(image) {
        if ( Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ) {
            Odigeo.UIElements.Cobalt.showBookingAlreadyDone();
        } else {
            let popup;
            let buttons;

            buttons = [
                {
                    text: Odigeo.UIElements.translations.alreadyConfirmed.button,
                    style: 'od-ui-dialog-button-default',
                    handler: function() {
                        Odigeo.UIElements.hideDialog(popup);
                        Odigeo.Utils.goToApplicationHome(Odigeo.Utils.isRequestApp('dp'));
                    },
                },
            ];

            popup = Odigeo.UIElements.createDialog('<b>' + Odigeo.UIElements.translations.alreadyConfirmed.title + '</b>',
                Odigeo.UIElements.translations.alreadyConfirmed.desc, buttons, '', false, image);

            Odigeo.UIElements.showDialog(popup);
        }
    };

    Odigeo.UIElements.showSessionLoginExpirationError = function() {
        var page = Odigeo.History.getPageNameFromFragment();
        var sessionLoginExpirePages = Odigeo.Settings.getProperty('sessionLoginExpirePages');

        if (Odigeo._.indexOf(sessionLoginExpirePages, page) < 0 ||
                Odigeo._.isNull(Odigeo.Utils.readCookie('sso_remember_me'))) {
            return;
        }

        Odigeo.Router.navigate('loginexpired');
    };

    Odigeo.UIElements.loadingMyTripsDialog = function() {
        return Odigeo.UIElements.loadingMyTripsDialogByTemplate();
    };

    Odigeo.UIElements.loadingMyTripsErrorDialog = function() {
        return Odigeo.UIElements.loadingMyTripsErrorDialogByTemplate();
    };

    Odigeo.UIElements.showSessionExpiredError = function(image, reverseButtons) {
        const page = Odigeo.History.getPageNameFromFragment();
        Odigeo.trigger('frontend-shell:session-expired');

        if (Odigeo._.contains(Odigeo.Settings.getProperty('sessionExpirePages'), Odigeo.History.getPageNameFromFragment())) {
            if (Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'))) {
                Odigeo.UIElements.showSessionExpiredErrorAccommodationPB();
            } else if (Odigeo.Utils.isRequestApp('dp') && Odigeo.SessionScope.flow === 'desktop') {
                Odigeo.UIElements.showDynpackSessionExpiredError();
            } else if (!Odigeo.Utils.isRequestApp('dp') &&
                Odigeo.SessionScope.flow === 'mobile' &&
                Odigeo.AB.isExpiredSessionReturningVisitors &&
                page !== 'results') {
                Odigeo.UIElements.showDynpackSessionExpiredErrorReturningVisitors();
            } else {
                Odigeo.UIElements.showSessionExpiredErrorByTemplate();
            }
        }
    };

    Odigeo.UIElements.showSearchExpiredErrorAccommodationPB = function() {
        var translationRetry = Odigeo.UIElements.translations.errBrokenFlowAccommodationPostBooking.button;
        var translations = Odigeo.UIElements.translations.errSearchExpired;
        var page = Odigeo.History.getPageNameFromFragment() || 'flights';
        var searchExpirePages = Odigeo.Settings.getProperty('searchExpirePages');
        var buttons = [{
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translationRetry}),
            style: 'od-ui-dialog-button-default',
            handler: function() {
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.Utils.launchAccommodationPBSearch();
            },
        }];
        var popup;

        // Only show the dialog at selected pages
        if (Odigeo._.indexOf(searchExpirePages, page) < 0) {
            return;
        }

        popup = Odigeo.UIElements.createDialog({
            headerText: translations.header,
            content: translations.content,
            buttons: buttons,
            dialogClasses: 'dialog_error',
        });

        Odigeo.UIElements.hideAllDialogs();
        Odigeo.UIElements.showDialog(popup);
    };

    Odigeo.UIElements.showSearchExpiredError = function() {
        var translations = Odigeo.UIElements.translations.errSearchExpired;
        var page = Odigeo.History.getPageNameFromFragment() || 'flights';
        var searchExpirePages = Odigeo.Settings.getProperty('searchExpirePages');
        var buttons = [];
        var popup;

        // Only show the dialog at selected pages
        if (Odigeo._.indexOf(searchExpirePages, page) < 0) {
            return;
        }

        if ( Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix ) {
            Odigeo.UIElements.Cobalt.showSearchExpiredErrorByTemplate();
            return;
        }

        buttons[0] = {
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.buttons[0].title})
                .add(translations.buttons[0].subtitle === '' ?
                    '' :
                    $('<p>', {'class': 'od-dialog-text-normal', 'text': translations.buttons[0].subtitle})),
            style: 'od-ui-dialog-button-cancel',
            handler: function() {
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.Utils.goToApplicationHome(Odigeo.Utils.isRequestApp('dp'));
            },
        };

        buttons[1] = {
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.buttons[1].title})
                .add(translations.buttons[0].subtitle === '' ?
                    '' :
                    $('<p>', {'class': 'od-dialog-text-normal', 'text': translations.buttons[1].subtitle})),
            style: 'od-ui-dialog-button-default',
            handler: function() {
                Odigeo.UIElements.hideAllDialogs();

                Odigeo.trigger('sessionExpireDialog:repeatSearch');
            },
        };

        popup = Odigeo.UIElements.createDialog({
            id: `${Odigeo.SessionScope.flowProduct}-popup-session-expired`,
            headerText: translations.header,
            content: translations.content,
            buttons: buttons,
            dialogClasses: 'dialog_error',
        });

        Odigeo.UIElements.hideAllDialogs();

        Odigeo.UIElements.showDialog(popup);
    };
    Odigeo.UIElements.showSessionAboutToExpireAlert = function(options = {}) {
        const idleWait = 10000;
        let idleTimer = null;
        const resetIdleTimer = () => {
            clearTimeout(idleTimer);
            idleTimer = setTimeout(showAlert, idleWait);
        };
        const showAlert = () => {
            const isNoOtherDialogsOpen = Odigeo._.isEmpty(this.dialogs)
                && Odigeo._.isEmpty(this.widgetsDialogs)
                && Odigeo._.isEmpty(Odigeo.UIElements.lightboxes);
            const isValidPage = Odigeo._.contains(
                Odigeo.Settings.getProperty('sessionAboutToExpirePages'),
                Odigeo.History.getPageNameFromFragment(),
            );
            const canShowAlert = isNoOtherDialogsOpen && isValidPage;
            if (canShowAlert) {
                Odigeo.UIElements.showSessionAboutToExpireAlertByTemplate(options);
                document.removeEventListener('keydown', resetIdleTimer);
                document.removeEventListener('click', resetIdleTimer);
                document.removeEventListener('scroll', resetIdleTimer);
            }
        };
        document.addEventListener('keydown', resetIdleTimer);
        document.addEventListener('click', resetIdleTimer);
        document.addEventListener('scroll', resetIdleTimer);
        idleTimer = setTimeout(showAlert, idleWait);
    };

    Odigeo.UIElements.showHurryUpAlertInXmin = function(options = {}) {
        let idleTimer = null;
        const showAlert = () => {
            const alreadyShownHurryUpAlertInXMin = !Odigeo.Session.get('hasAlreadyShownHurryUpAlertInXMin');
            const isNoOtherDialogsOpen = Odigeo._.isEmpty(this.dialogs)
                && Odigeo._.isEmpty(this.widgetsDialogs)
                && Odigeo._.isEmpty(Odigeo.UIElements.lightboxes);
            const isValidPage = Odigeo._.contains(
                Odigeo.Settings.getProperty('sessionAboutToExpirePages'),
                Odigeo.History.getPageNameFromFragment(),
            );
            const canShowAlert = alreadyShownHurryUpAlertInXMin && isNoOtherDialogsOpen && isValidPage;
            if (canShowAlert) {
                Odigeo.UIElements.showSessionAboutToExpireAlertByTemplate(options);
                Odigeo.Session.set('hasAlreadyShownHurryUpAlertInXMin', true);
                clearTimeout(idleTimer);
            }
        };
        idleTimer = setTimeout(showAlert, options.time);
    };

    Odigeo.UIElements.showValidationError = function(pagesList) {
        var translations = Odigeo.UIElements.translations.alertValidationError;
        var buttons = [];
        var popup;

        buttons[0] = {
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.button}),
            style: 'od-ui-dialog-button-default',
            handler: function() {
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.Router.reload();
            },
        };

        popup = Odigeo.UIElements.createDialog({
            id: `${Odigeo.SessionScope.flowProduct}-popup-validation-error`,
            headerText: translations.header,
            content: translations.content,
            buttons: buttons,
            dialogClasses: 'dialog_error',
        });
        Odigeo.UIElements.hideAllDialogs();
        Odigeo.UIElements.showDialog(popup);
    };

    Odigeo.UIElements.buildAccommodationPBBrokenFlowErrorPopUp = function(image) {
        var translations = Odigeo.UIElements.translations.errBrokenFlowAccommodationPostBooking;
        var page = Odigeo.History.getPageNameFromFragment();
        var buttons = [{
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.button}),
            style: 'od-ui-dialog-button-default',
            handler: function() {
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
                Odigeo.Session.set('comesFromError', true);
                Odigeo.trigger('frontend-shell:restore-render-error');
                if (Odigeo.History.getPageNameFromFragment() === 'detailsloading') {
                    Odigeo.Router.navigate('xsellproductselection');
                } else {
                    Odigeo.Utils.launchAccommodationPBSearch();
                }
            },
        }];
        return Odigeo.UIElements.createDialog({
            headerText: translations.header,
            content: translations.content,
            buttons: buttons,
            dialogClasses: 'dialog_error od-dialog-' + page,
            imageClass: image,
        });
    };

    Odigeo.UIElements.buildBrokenFlowErrorPopup = function(image, reverseButtons) {
        var translations = Odigeo.UIElements.translations.errBrokenFlow;
        var page = Odigeo.History.getPageNameFromFragment();
        var buttons = [];
        var isDynpack = Odigeo.Utils.isRequestApp('dp');

        buttons[0] = {
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.buttons[0].title})
                .add(translations.buttons[0].subtitle === '' ?
                    '' :
                    $('<p>', {'class': 'od-dialog-text-normal', 'text': translations.buttons[0].subtitle})),
            style: 'od-ui-dialog-button-cancel',
            handler: function() {
                trackingUtils.trackEvent('request_errors', 'broken_flow_try_new_dates');
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.Utils.goToApplicationHome(isDynpack);
            },
        };

        buttons[1] = {
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.buttons[1].title})
                .add(translations.buttons[0].subtitle === '' ?
                    '' :
                    $('<p>', {'class': 'od-dialog-text-normal', 'text': translations.buttons[1].subtitle})),
            style: 'od-ui-dialog-button-default',
            handler: function() {
                trackingUtils.trackEvent('request_errors', 'broken_flow_retry_search');
                Odigeo.trigger('frontend-shell:restore-render-error');
                Odigeo.trigger('sessionExpireDialog:repeatSearch', Odigeo.History.getPageNameFromFragment());
            },
        };

        if (!Odigeo._.isUndefined(reverseButtons) && reverseButtons) {
            buttons = buttons.reverse();
        }

        return Odigeo.UIElements.createDialog({
            id: `${Odigeo.SessionScope.flowProduct}-popup-broken-flow`,
            headerText: translations.header,
            content: translations.content,
            buttons: buttons,
            dialogClasses: 'dialog_error od-dialog-' + page,
            imageClass: image,
        });
    };

    Odigeo.UIElements.showAlreadyUsedError = function() {
        var translations = Odigeo.UIElements.translations.alreadyUsedError;
        var buttons = [];
        var popup;

        buttons[0] = {
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.buttons[0].title}),
            style: 'od-ui-dialog-button-cancel',
            handler: function() {
                Odigeo.trigger('analytics:tracking', {
                    type: 'trackEvent',
                    data: {
                        category: 'post_booking',
                        action: 'nags',
                        label: 'accommodation_checkout_error_check_email_newsearch',
                    },
                });
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.Utils.launchAccommodationPBSearch();
            },
        };

        buttons[1] = {
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.buttons[1].title}),
            style: 'odf-btn odf-btn-primary odf-btn-lg odf-space-outer-s odf-nospace-outer-left odf-nospace-outer-bottom',
            handler: function() {
                Odigeo.trigger('analytics:tracking', {
                    type: 'trackEvent',
                    data: {
                        category: 'post_booking',
                        action: 'nags',
                        label: 'accommodation_checkout_error_check_email_clickok',
                    },
                });
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.Utils.goToApplicationHome(Odigeo.Utils.isRequestApp('dp'));
            },
        };

        popup = Odigeo.UIElements.createDialog({
            headerText: translations.header,
            content: translations.content,
            buttons: buttons,
            dialogClasses: 'dialog_error already-used-link-dialog',
        });

        Odigeo.UIElements.hideAllDialogs();

        Odigeo.UIElements.showDialog(popup);

        // Analytics: event tracking
        Odigeo.trigger('analytics:tracking', {
            type: 'trackEvent',
            data: {
                category: 'post_booking',
                action: 'nags',
                label: 'accommodation_checkout_error_check_email_onload',
            },
        });
    };

    Odigeo.UIElements.showBrokenFlowError = function(image, reverseButtons) {
        trackingUtils.trackEvent('request_errors', 'broken_flow_message');

        if (Odigeo.AB.isCssVariationMobile || Odigeo.AB.isMetaPrimePriceFix) {
            if ( Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking')) ) {
                Odigeo.UIElements.Cobalt.showAccommodationPBBrokenFlowErrorPopUpByTemplate();
            } else {
                Odigeo.UIElements.Cobalt.showBrokenFlowErrorPopupByTemplate( reverseButtons );
            }
            return;
        }

        let popup;
        if (Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'))) {
            popup = this.buildAccommodationPBBrokenFlowErrorPopUp(image);
        } else {
            popup = this.buildBrokenFlowErrorPopup(image, reverseButtons);
        }
        Odigeo.UIElements.hideAllDialogs();
        Odigeo.UIElements.showDialog(popup);
    };

    Odigeo.UIElements.showSelectionError = function(error = {}) {
        trackingUtils.trackEvent('request_errors', 'broken_flow_message');
        Odigeo.UIElements.hideAllDialogs();
        const path = Odigeo.History.getPageNameFromFragment();
        const modalPath = path.includes('checkout_flight_summary_results') ? 'checkout_flight_summary_results' : path;
        const errorMessage = Odigeo._.isString(error.message) ? error.message.split(':')[0].substring(0, 35) : '';
        const errorCode = Odigeo._.isString(error.code) ? error.code.toLowerCase() : '';
        const trackLabel = `broken_flow_message_path_${modalPath}_error_code_${errorCode}_error_message_${errorMessage}`;
        const portal = `<div id="alternative_flight_modal_${modalPath}_container" class="shell-integration_portal"></div>`;
        trackFrontEventsUtils.trackComponentDisplayedEvent(trackLabel);
        $(`#alternative_flight_modal_${modalPath}_wrapper`).html(portal);
    };

    Odigeo.UIElements.showNoContractBookingAccommodationPBError = function(image) {
        var translations = Odigeo.UIElements.translations.errNoContractBookingAccommodationPB;
        var buttons = [{
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.button}),
            style: 'od-ui-dialog-button-default',
            handler: function() {
                Odigeo.UIElements.hideAllDialogs();
                Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
                Odigeo.trigger('dialog:redirectToHome');
            },
        }];
        var popup = Odigeo.UIElements.createDialog({
            headerText: translations.header,
            content: translations.content,
            buttons: buttons,
            dialogClasses: 'dialog_error',
            imageClass: image,
        });

        Odigeo.UIElements.hideAllDialogs();
        Odigeo.UIElements.showDialog(popup);
    };

    Odigeo.UIElements.showAgeValidationError = function(age) {
        var translations = Odigeo.UIElements.translations.ageValidationError;
        var buttons = [];
        var content;
        var popup;

        content = age === 'baby' ? translations.content_baby : translations.content_kid;

        buttons[0] = {
            text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.button}),
            style: 'od-ui-dialog-button-default',
            handler: function() {
                Odigeo.trigger('sessionExpireDialog:repeatSearch');
            },
        };

        popup = Odigeo.UIElements.createDialog({
            headerText: translations.header,
            content: content,
            buttons: buttons,
            dialogClasses: 'dialog_error',
            hasCloseButton: true,
        });
        Odigeo.UIElements.hideAllDialogs();
        Odigeo.UIElements.showDialog(popup);
    };

    Odigeo.UIElements._getCategoryAnalytics = function(page) {
        var category = 'home';
        switch (page) {
            case 'results':
                category = 'flights_results';
                break;
            case 'details':
                category = 'flights_pax_page';
                break;
            case 'payment':
                category = 'flights_pay_page';
                break;
            case 'confirmation':
                category = 'flights_confirmation_page';
                break;
        }
        return category;
    };

    Odigeo.UIElements.showNoResultsPopup = function(texts) {
        var resetBtn = {
            text: $('<p>', {
                'class': 'od-dialog-text-main',
                'text': texts.resetBtn,
            }),
            style: 'od-ui-dialog-button-default',
            handler: function() {
                Odigeo.UIElements.hideDialog(popup);
                Odigeo.trigger('dialog:launchNoResults');
                // Force to replace hash to avoid errors with back button
                Odigeo.Utils.goToApplicationHome();
            },
        };
        var popup = Odigeo.UIElements.createDialog({
            id: `${Odigeo.SessionScope.flowProduct}-popup-no-results`,
            headerText: texts.labelops,
            content: texts.labelnoresults,
            buttons: [resetBtn],
            dialogClasses: 'dialog_error',
            imageClass: 'alert',
        });

        if (Odigeo.SessionScope.flow === 'mobile' && Odigeo.History.getPageNameFromFragment() === 'results') {
            Odigeo.trigger('analytics:tracking', {
                type: 'trackEvent',
                data: {
                    page: Odigeo.History.getPageNameFromFragment(),
                    action: 'results_filters',
                    label: 'filtering_no_results_error_impossiblesearch_onload',
                },
            });
            const $errorButton = popup.find('button');
            $errorButton.on(Odigeo.Events.tap, function() {
                Odigeo.trigger('analytics:tracking', {
                    type: 'trackEvent',
                    data: {
                        page: Odigeo.History.getPageNameFromFragment(),
                        action: 'results_filters',
                        label: 'filtering_no_results_error_impossiblesearch_newsearch',
                    },
                });
            });
            popup.on(Odigeo.Events.tap, function(e) {
                e.stopPropagation();
                e.preventDefault();
                if (e.target.className.indexOf('dialog_content') !== -1) {
                    Odigeo.trigger('analytics:tracking', {
                        type: 'trackEvent',
                        data: {
                            page: Odigeo.History.getPageNameFromFragment(),
                            action: 'results_filters',
                            label: 'filtering_no_results_error_impossiblesearch_close_greyarea',
                        },
                    });
                }
            });
        }

        Odigeo.UIElements.showDialog(popup);
    };

    Odigeo.UIElements.showLightboxWarning = function(imageClass, primaryAction, secondaryAction, translations) {
        var buttons = [];
        var $popup;
        var $header;
        var isModal = !Odigeo._.isFunction(secondaryAction);
        var $image = $('<div>').addClass(imageClass);
        var $headerTitle = $('<p>', {
            'text': translations.headerTitle,
            'class': 'odf-h2 odf-text-center odf-strong od-ui-dialog-lightbox-header',
        });
        var $description = $('<p>', {
            'html': translations.description,
            'class': 'odf-text-md odf-text-center odf-text-light od-ui-dialog-lightbox-description',
        });

        $header = $('<div>').append($image).append($headerTitle).append($description);
        buttons.push({
            text: $('<p>', {'text': translations.primaryButton}),
            style: 'odf-btn odf-btn-primary odf-btn-block',
            handler: function(evt) {
                evt.stopPropagation();
                evt.preventDefault();
                Odigeo.UIElements.hideDialog($popup);
                if (Odigeo._.isFunction(primaryAction)) {
                    primaryAction();
                }
            },
        });
        if (!isModal) {
            buttons.push({
                text: $('<a>', {'text': translations.secondaryButton}),
                style: 'od-ui-dialog-lightbox-secondary-button od-ui-dialog-button-link',
                handler: function(evt) {
                    evt.stopPropagation();
                    evt.preventDefault();
                    Odigeo.UIElements.hideDialog($popup);
                    if (Odigeo._.isFunction(secondaryAction)) {
                        secondaryAction(true);
                    }
                },
            });
        }

        $popup = Odigeo.UIElements.createDialog({
            headerText: $header,
            buttons: buttons,
            dialogClasses: 'lightbox_warning od-ui-dialog-lightbox',
            hasCloseButton: !isModal,
            closeOnTapOuterBox: false,
            closeOnNavigate: true,
        });
        if (!isModal) {
            $popup.find('.dialog_close_hint_icon').on(Odigeo.Events.tap, secondaryAction);
        }
        $popup.find('.od-ui-dialog-close-hint-icon').toggleClass('odf-hidden', isModal);
        Odigeo.UIElements.showDialog($popup);
    };

    /**
     * Dialog shown by nagmanager. Those are dialogs with background image, a title and 2 buttons
     * @param {String} [dialogclasses] specifics classes for the nag popup
     * @param {Object} [translations]
     * @param {Function} [cb1] callback for button 1
     * @param {Function} [cb2] callback for button 2
     * @param {Object} [tracking] tracking for the nagPopup
     * @param {String} [footerText] footerText for the nagPopup
     * @param {String} [content] content for the nagPopup
     * @param {Boolean} [hasToCloseOnButtonClick] hasToCloseOnButtonClick boolean for the nagPopup
     * @param {Boolean} [hasCloseButton] hasCloseButton boolean for the nagPopup
     */
    Odigeo.UIElements.showNagPopup = function(dialogclasses, translations, cb1, cb2, tracking, footerText, content,
        hasToCloseOnButtonClick, hasCloseButton) {
        var buttons = [];
        var popup;
        var header;
        var $subtitleBold = $('<span>', {'class': 'od-ui-dialog-box-subtitle-bold', 'text': translations.subtitleBold});
        var $subtitle = $('<p class="od-ui-dialog-box-subtitle">' + translations.subtitle + '</p>');

        if (!Odigeo._.isUndefined(translations.subtitleBold)) {
            $subtitle.append($subtitleBold);
        }

        // Dialog Header
        header = $('<div>', {'class': 'od-nag-baggages-dialog-title', 'text': translations.title || ''}).append($subtitle);

        // Dialog buttons
        buttons.push({
            text: $('<p>', {
                'id': 'dialog_btn_1',
                'class': 'od-dialog-text-main',
                'text': translations.button1 || '',
            }),
            style: 'odf-btn-secondary odf-btn od-nagbutton-secondary nag_button_accept',
            handler: function(event) {
                event.preventDefault();
                event.stopPropagation();
                Odigeo.trigger('analytics:tracking', {
                    type: 'trackEvent',
                    data: {
                        page: Odigeo.History.getPageNameFromFragment(),
                        action: 'nags',
                        label: tracking.add,
                    },
                });
                if (!hasToCloseOnButtonClick) {
                    Odigeo.UIElements.hideDialog(popup);
                }
                if (Odigeo._.isFunction(cb1)) {
                    cb1();
                }
            },
        });

        buttons.push({
            text: $('<p>', {
                'class': 'od-dialog-text-main',
                'text': translations.button2 || '',
            }),
            style: 'od-ui-dialog-button-default nag_button_dismiss',
            handler: function(event) {
                event.preventDefault();
                event.stopPropagation();
                Odigeo.trigger('analytics:tracking', {
                    type: 'trackEvent',
                    data: {
                        page: Odigeo.History.getPageNameFromFragment(),
                        action: 'nags',
                        label: tracking.skip,
                    },
                });
                if (!hasToCloseOnButtonClick) {
                    Odigeo.UIElements.hideDialog(popup);
                }
                if (Odigeo._.isFunction(cb2)) {
                    cb2();
                }
            },
        });

        // Dialog creation and show
        popup = Odigeo.UIElements.createDialog({
            headerText: header,
            buttons: buttons,
            dialogClasses: 'nag_dialog od-nag-dialog ' + (dialogclasses || ''),
            hasCloseButton: hasCloseButton || false,
            closeOnTapOuterBox: false,
            closeOnNavigate: true,
            footerText: footerText,
            content: content,
        });

        Odigeo.UIElements.showDialog(popup, true);
        Odigeo.trigger('analytics:tracking', {
            type: 'trackEvent',
            data: {
                page: Odigeo.History.getPageNameFromFragment(),
                action: 'nags',
                label: tracking.appearances,
            },
        });
    };

    Odigeo.UIElements.showBackToHomeError = function() {
        var translations = Odigeo.UIElements.translations.errBrokenFlow;
        var buttons = [];
        var popup;

        buttons.push({text: $('<p>', {'class': 'od-dialog-text-main', 'text': translations.buttons[0].title})
            .add(translations.buttons[0].subtitle === '' ?
                '' :
                $('<p>', {'class': 'od-dialog-text-normal', 'text': translations.buttons[0].subtitle})),
        style: 'od-ui-dialog-button-cancel',
        handler: function() {
            Odigeo.UIElements.hideAllDialogs();
            Odigeo.Utils.goToApplicationHome(Odigeo.Utils.isRequestApp('dp'));
        },
        });

        popup = Odigeo.UIElements.createDialog({
            id: `${Odigeo.SessionScope.flowProduct}-popup-broken-flow`,
            headerText: translations.header,
            content: translations.content,
            buttons: buttons,
            dialogClasses: 'dialog_error',
        });

        Odigeo.UIElements.hideAllDialogs();
        Odigeo.UIElements.showDialog(popup);
    };

    Odigeo.UIElements.showUploadingResultsInfo = function(popupDiv) {
        var $el;
        var templateSettings = {
            evaluate: /\{\{#([\s\S]+?)\}\}/g,
            interpolate: /\{\{[^#\{]([\s\S]+?)[^\}]\}\}/g, // eslint-disable-line no-useless-escape
            escape: /\{\{\{([\s\S]+?)\}\}\}/g,
        };
        var showUploading;
        var showConfirm;

        $el = (popupDiv instanceof $) ? popupDiv : $(popupDiv);

        showUploading = function() {
            var template = Odigeo._.template(
                $el.html(),
                templateSettings);
            Odigeo.Device.getViewport().append(template());
        };

        showConfirm = function() {
            var $wrapper = $('.dialog_update_pax_selection');
            $wrapper.find('.addpax_loading').addClass('fadeout');
            $wrapper.find('.loading_new_pax_msg').addClass('odf-hidden');
            setTimeout(function() {
                $wrapper.find('.uploaded_new_pax_msg').removeClass('odf-hidden');
                $wrapper.find('.addpax_confirmation').removeClass('odf-hidden');
                $wrapper.find('.addpax_confirmation_icon_wrapper').addClass('active');
            }, 500);
        };

        return {
            uploading: showUploading,
            confirm: showConfirm,
        };
    };

    Odigeo.UIElements.createGenericDialog = function(options) {
        return Odigeo.UIElements.createGenericDialogByTemplate(options);
    };
}());
